import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { AICC_PROMPT_GROUPS_IN_ORDER, AICC_PROMPT_GROUP_SLUG } from "constants/aiccPrompt";
import PromptList from "./PromptList";
import PromptDetail from "./PromptDetail";
import SandboxHost from "./Sandbox/SandboxHost";

function PromptManagement() {
  const { path } = useRouteMatch();
  const firstTab = `${path}/${AICC_PROMPT_GROUP_SLUG[AICC_PROMPT_GROUPS_IN_ORDER[0]]}`;

  return (
    <>
      <Switch>
        <Route exact path={path}>
          <Redirect to={firstTab} />
        </Route>
        <Route exact path={`${path}/:group`}>
          <PromptList />
        </Route>
        <Route exact path={`${path}/:group/:promptKey`}>
          <PromptDetail />
        </Route>
        <Route path={path}>
          <Redirect to={firstTab} />
        </Route>
      </Switch>
      <Route exact path={`${path}/:group`}>
        <SandboxHost />
      </Route>
    </>
  );
}

export default PromptManagement;
